import React from 'react';
import { useStyletron } from 'baseui';
import { StatefulTooltip } from 'baseui/tooltip';
import { Alert } from 'baseui/icon';
import { GLOBAL_THEME } from 'commons-ui';

interface ILabelProps {
	label?: any;
	required?: any;
	toolTip?: any;
	description?: any;
}

const Label: React.FC<ILabelProps> = ({ label, required, toolTip, description }) => {
	const [css] = useStyletron();
	return (
		<div className={css({ display: 'flex', flexDirection: 'column' })}>
			<div className={css({ display: 'flex', flexDirection: 'row', alignItems: 'center' })}>
				<label
					className={css({
						display: 'flex',
						gap: '1px',
						color: GLOBAL_THEME.Colors.black,
						padding: '10px 5px 10px 0'
					})}>
					<div>{label}</div>
					<div className={css({ color: '#FA3E3E' })}>{required && '*'}</div>
				</label>
				{toolTip && (
					<StatefulTooltip accessibilityType='tooltip' placement='right' content={toolTip}>
						<Alert size={15} />
					</StatefulTooltip>
				)}
			</div>
			{description && (
				<div
					className={css({
						display: 'flex',
						fontSize: '12px',
						color: '#1976D2',
						marginBottom: '8px',
						paddingLeft: '0px',
						fontStyle: 'italic'
					})}>
					{description}
				</div>
			)}
		</div>
	);
};

export default Label;
